import React from 'react';
import { useNavigate } from 'react-router-dom';

export const BANNER_HEIGHT = 40;

export default function ImpersonationBanner({ user, onExit }) {
  const navigate = useNavigate();

  function handleExit() {
    onExit();
    navigate('/admin/users');
  }

  return (
    <div style={{
      position: 'fixed',
      top: 60,
      left: 0,
      right: 0,
      height: BANNER_HEIGHT,
      background: '#d97706',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
      fontSize: 13,
      fontWeight: 500,
      zIndex: 250,
      fontFamily: 'system-ui, -apple-system, sans-serif',
    }}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
        <circle cx="12" cy="12" r="3"/>
      </svg>
      Viewing as <strong style={{ marginLeft: 2 }}>{user.email}</strong>
      <button
        onClick={handleExit}
        style={{
          background: 'rgba(0,0,0,0.2)',
          border: '1px solid rgba(255,255,255,0.3)',
          color: '#fff',
          fontSize: 12,
          fontWeight: 600,
          padding: '3px 10px',
          borderRadius: 5,
          cursor: 'pointer',
          marginLeft: 4,
        }}
      >
        Exit
      </button>
    </div>
  );
}
